
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8 1.6a3.338 3.338 0 100 6.675A3.338 3.338 0 008 1.6zM3.462 4.938a4.537 4.537 0 119.075 0 4.537 4.537 0 01-9.075 0z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M2.955 11.335a7.663 7.663 0 0112.64 4.747.6.6 0 01-1.19.16 6.463 6.463 0 00-12.81 0 .6.6 0 01-1.19-.16 7.663 7.663 0 012.55-4.747z"}})])
          )
        }
      }
    